import React from 'react'
import BookingPage from '../../components/bookingPage'

export const BookingPageDetail = () => {
  return (
      <>
      <BookingPage />
      </>
)
}
